import { createI18n } from 'vue-i18n'
import en from './locales/en.json'
import ar from './locales/ar.json'

export type MessageSchema = typeof en

declare module 'vue-i18n' {
  // eslint-disable-next-line @typescript-eslint/no-empty-object-type
  export interface DefineLocaleMessage extends MessageSchema {}
}

const STORAGE_KEY = 'ecoaxis_locale'

export function getStoredLocale(): 'en' | 'ar' {
  if (typeof localStorage === 'undefined') return 'en'
  const v = localStorage.getItem(STORAGE_KEY)
  return v === 'ar' || v === 'en' ? v : 'en'
}

export function saveLocale(locale: 'en' | 'ar') {
  localStorage.setItem(STORAGE_KEY, locale)
}

export const i18n = createI18n({
  legacy: false,
  locale: getStoredLocale(),
  fallbackLocale: 'en',
  messages: { en, ar },
  missingWarn: false,
  fallbackWarn: false,
})
